import type {
  DataSourceDefinition,
  DataSourceDependencies,
  TypeReferenceBuilder,
  BindingContextDef,
  BindingContextRelationshipDef,
  BindablePropertiesDef,
} from '@packages/systems/dynamo/source-types';

import {
  defineSiteUserTypes,
  defineSiteUserBindingContexts,
  defineSiteUserRelationships,
  defineSiteUserBindableProperties,
} from './site-user';
import {Plugins} from '@packages/systems/wfdl';

export {
  USER_SUBSCRIPTION_COLLECTION_ID,
  USER_SUBSCRIPTION_COLLECTION,
} from './site-user';

// TODO (dynamo) Remove these imports once `validateDynamicContext` works with
//  Dynamo gateway.
// Exporting these binding context type IDs is temporary, and we use these to
// make the legacy binding context validation work with the modern binding
// context that User Systems is using.
export {SITE_USER_SUBSCRIPTION_BINDING_CONTEXT_TYPE_ID} from './identifiers';

export const dataSourceDefinition: DataSourceDefinition = {
  pluginName: Plugins.name('Users'),

  defineTypes() {
    return [...defineSiteUserTypes()];
  },

  defineBindingContexts<RootTRef, EntityTRef, ListTRef>(
    _deps: DataSourceDependencies,
    referenceBuilder: TypeReferenceBuilder<RootTRef, EntityTRef, ListTRef>
  ): BindingContextDef<RootTRef, EntityTRef, ListTRef>[] {
    return [...defineSiteUserBindingContexts(referenceBuilder)];
  },

  defineRelationships<RootTRef, EntityTRef, ListTRef>(
    _dependencies: DataSourceDependencies,
    referenceBuilder: TypeReferenceBuilder<RootTRef, EntityTRef, ListTRef>
  ): BindingContextRelationshipDef<RootTRef, EntityTRef>[] {
    return [...defineSiteUserRelationships(referenceBuilder)];
  },

  defineBindableProperties<RootTRef, EntityTRef, ListTRef>(
    dependencies: DataSourceDependencies,
    referenceBuilder: TypeReferenceBuilder<RootTRef, EntityTRef, ListTRef>
  ): BindablePropertiesDef<EntityTRef, ListTRef>[] {
    return [...defineSiteUserBindableProperties(referenceBuilder)];
  },
};
